import React from "react";
import {bindActionCreators} from "redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import {connect} from "react-redux";
import GameComponent from "game/app/components/game/game-component";
import {loadQuestions} from "game/app/actions/knowledge-questions";
import {Link} from "react-router-dom";
import GameInstance from "common/models/game-instance";
import assets from "game/app/assets";

class PickTransportation extends GameComponent {

    selectTransportation = (transportationIndex) => {
        this.props.sendInput(this.props.gameInstance.instance.id, { type: 'pick_transportation', transportation: transportationIndex })
            .then(() => this.props.loadQuestions(this.getInstanceId()))
    };

    render() {
        let housing = this.getHousing();
        let selectedTransportation = this.getInstanceProperty('PROFILE_TRANSPORTATION');

        if (housing === undefined) {
            return (<div className='alert alert-warning'>Nejdříve zvolte typ bydlení</div>)
        }

        let localityId = housing['locality'];
        let locations = this.getProfileProperty('transportation');
        let locality = locations.find((location) => { return location.id === localityId });

        let options =
            locality['options']
                .map((transportationOption, transportationIndex) => {
                    let isSelectedTransportation = transportationIndex === selectedTransportation;
                    let className = 'question-options__option ' + (selectedTransportation >= 0 ? (isSelectedTransportation ? 'selected' : 'inactive') : '');

                    let money_resources = transportationOption.resources
                        .filter((resource) => GameInstance.MONEY_RESOURCES.includes(resource['type']))
                        .map((money, key) => (<div key={key}><span className={money['amount'] < 0 ? 'text-danger' : ''}>{ (money['amount'] > 0 ) ? '+' : '' }{ money['amount'].toLocaleString(this.locale) } <small>Kč{ money['repeat'] ? '/měs' : '' }</small></span> <img src={assets.resources.money_tiny}/></div>));

                    return (
                        <li key={transportationIndex} className={className} onClick={() => this.selectTransportation(transportationIndex)}>
                            <div className='question-options__option__id'>{String.fromCharCode(65 + transportationIndex)}</div>
                            <div className='question-options__option__text'>
                                { !transportationOption.preferred && <span style={{'whiteSpace': 'pre-line'}}>{ transportationOption.description }</span> }
                                { transportationOption.preferred && <p style={{'whiteSpace': 'pre-line'}}>{ transportationOption.description }</p> }
                                { transportationOption.preferred && <div className='small text-success'>Lidé jako vy obvykle volí tuto možnost</div> }
                            </div>
                            <div className='question-options__option__resources'>{ money_resources }</div>
                        </li>
                    )
                });

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <div className='separate-bottom'>
                            <h1 className='page-title-minor separate-bottom'>Doprava</h1>
                            <p>{ locality['description'] }</p>
                        </div>
                        <p className='label'>Možnosti dopravy</p>
                        <ul className='question-options'>
                            { options }
                        </ul>
                        <div className='separate'><Link to={`/game/${this.getInstanceId()}/round-1`} className='btn btn-primary'>Zpět na výběr profilu</Link></div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput,
        loadQuestions: loadQuestions
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(PickTransportation);
